import { type CSSProperties, type HTMLAttributes } from 'react';
import styles from './UnreadNotificationIcon.module.css';

interface UnreadNotificationIconProps
  extends Omit<HTMLAttributes<HTMLSpanElement>, 'className' | 'style'> {
  className?: string;
  style?: CSSProperties;
  position?: 'center' | 'topRight';
}

/**
 * Small circular marker used for unread resource requests.
 */
export function UnreadNotificationIcon({
  className,
  'aria-hidden': ariaHidden,
  style,
  position = 'topRight',
  ...rest
}: UnreadNotificationIconProps): JSX.Element {
  const positionClassName =
    position === 'center' ? styles.center : styles.topRight;

  const combinedClassName = [
    styles.unreadNotificationIcon,
    positionClassName,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span
      className={combinedClassName}
      style={style}
      aria-hidden={ariaHidden ?? 'true'}
      {...rest}
    />
  );
}
